if (!customElements.get('store-availability')) {
  customElements.define(
    'store-availability',
    class StoreAvailability extends HTMLElement {
      connectedCallback() {
        this.sectionEl = document.getElementById(`ProductSection-${this.dataset.sectionId}`);
        this.masterSelect = document.getElementById(`ProductSelect-${this.dataset.sectionId}`);
        this.onChange = this.onChange.bind(this);
        this.sectionEl?.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.sectionEl?.removeEventListener('change', this.onChange);
      }

      onChange() {
        const variantId = this.masterSelect?.value;
        const template = variantId && this.querySelector(`[data-store-availability-template="${variantId}"]`);
        if (!template) return;

        const status = template.content.querySelector('[data-store-availability-status]');
        const body = template.content.querySelector('[data-store-availability-body]');
        const liveStatus = this.querySelector('[data-store-availability-button] [data-store-availability-status]');
        const modalSelector = this.querySelector('[data-store-availability-button]')?.dataset.target;
        const liveBody = (modalSelector ? document.querySelector(modalSelector) : this)?.querySelector(
          '[data-store-availability-body]'
        );

        if (status && liveStatus) liveStatus.className = status.className;
        if (body && liveBody) liveBody.innerHTML = body.innerHTML;
      }
    }
  );
}
